<script lang="ts">
	import type { i18n, SvelteAsr } from 'types/common'
	import type { Chart } from '@isoftdata/utility-dashboard-backend'

	import { getContext, type ComponentProps } from 'svelte'
	import { ManageConfiguration } from '@isoftdata/svelte-dashboard'
	import { AsrNavTabBar } from '@isoftdata/svelte-nav-tab-bar'
	import { checkSessionPermission } from 'utility/permission'

	type ManageProps = ComponentProps<typeof ManageConfiguration>

	interface Props {
		asr: SvelteAsr
		dashboardReportId: number | null
		groups: ManageProps['groups']
		plants: ManageProps['sites']
		users: ManageProps['users']
		reports: ManageProps['reports']
		canEditOwn: boolean
		canEditAll: boolean
		charts: Array<Chart>
	}

	let {
		//
		asr,
		dashboardReportId = $bindable(),
	}: Props = $props()

	const { t: translate } = getContext<i18n>('i18next')
</script>

<div class="card">
	<div class="card-header">
		<AsrNavTabBar
			{asr}
			tabs={[
				{
					name: 'app.configuration.dashboard.report',
					title: translate('common:reports', 'Reports'),
					disabled:
						!checkSessionPermission('DASHBOARD_REPORT_EDIT_ALL') &&
						!checkSessionPermission('DASHBOARD_REPORT_EDIT_OWN'),
				},
				{
					name: 'app.configuration.dashboard.chart',
					title: translate('common:charts', 'Charts'),
					disabled: !checkSessionPermission('DASHBOARD_CHART_EDIT'),
				},
			]}
		></AsrNavTabBar>
	</div>
	<div class="card-body">
		<uiView></uiView>
	</div>
</div>
